import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/studio-hire', label: 'Studio Hire' },
    { path: '/bespoke-set-design-construction', label: 'Set Design' },
    { path: '/fashion-events', label: 'Fashion & Events' },
    { path: '/boudoir-intimate-photography', label: 'Boudoir' },
    { path: '/scene-production', label: 'Scene Production' },
    { path: '/professionals', label: 'Photographer Hire' },
    { path: '/freelance-models', label: 'Models' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/about', label: 'About' },
    { path: '/contact', label: 'Contact' }
  ];

  // Application form links for mobile menu
  const applicationLinks = [
    { path: '/model-signup', label: 'Model Sign Up' },
    { path: '/join-our-team', label: 'Photographer Sign Up' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-sm border-b border-red-900/20">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="text-2xl font-display font-bold text-white hover:text-red-400 transition-colors">
            EWS PRODUCTIONS
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link text-sm tracking-wider ${
                  isActive(link.path)
                    ? 'text-red-500'
                    : 'text-gray-400 hover:text-red-400'
                } transition-colors`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-red-500 hover:text-red-400 transition-colors"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden pb-6 pt-2 border-t border-red-900/20">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className={`block py-3 text-sm tracking-wider ${
                  isActive(link.path)
                    ? 'text-red-500'
                    : 'text-gray-400 hover:text-red-400'
                } transition-colors`}
              >
                {link.label}
              </Link>
            ))}
            
            {/* Application Forms Section */}
            <div className="mt-4 pt-4 border-t border-red-900/20">
              <p className="text-xs text-gray-500 uppercase tracking-wider mb-2">Apply Now</p>
              {applicationLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`block py-3 text-sm tracking-wider ${
                    isActive(link.path)
                      ? 'text-red-500'
                      : 'text-green-400 hover:text-green-300'
                  } transition-colors`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;